import axios from "axios";
import { useState } from "react";
import { Navigate, useNavigate } from "react-router-dom";
function ForgotPasswordFn() {
    const [email, setEmail] = useState('');
    const [error, setError] = useState('');
    const [message, setMessage] = useState('');
    const [loading, setLoading] = useState(false);
     const navigate = useNavigate()

    async function handleSubmit(e:any) {
        e.preventDefault();
        setLoading(true);
        setError('');
        setMessage('');
        try {
            const response = await axios.post(
                '/api/v1/authenticate/forgot-password',
                JSON.stringify({ email }),
                {
                    headers: { 'Content-Type': 'application/json' },
                    withCredentials: true
                }
            );
            setMessage(
                response.data?.message ||
                "If this email is registered, a password reset link has been sent."
            );
            setEmail('');
        } catch (err:any) {
            const errorMsg =
                err.response?.data?.errors?.[0]?.message ||
                "Resend email instruction failed. Please try again.";
            setError(errorMsg);
            console.error("Login error:", err);
        } finally {
            setLoading(false)
        }
    }

    return (
        <div className="min-h-screen flex items-center justify-center bg-gray-100 dark:bg-gray-900">
            <form
                className="w-full max-w-md bg-white dark:bg-gray-800 rounded-lg shadow-lg p-8"
                onSubmit={handleSubmit}
            >
                <h2 className="text-2xl font-bold text-gray-800 dark:text-white mb-6 text-center">
                    Forgot Password
                </h2>
                {error && (
                    <p className="text-red-500 text-sm text-center mb-4">
                        {error}
                    </p>
                )}
                {message && (
                    <p className="text-green-500 text-sm text-center mb-4">
                        {message}
                    </p>
                )}
                <div className="mb-5">
                    <label
                        htmlFor="email"
                        className="block mb-2 text-sm font-medium text-gray-900 dark:text-white"
                    >
                        Enter your email address
                    </label>
                    <input
                        type="email"
                        id="email"
                        className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 transition duration-150 ease-in-out dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                        onChange={(e) => {
                            setEmail(e.target.value);
                            if (error) setError('');
                        }}
                        value={email}
                        required
                    />
                </div>
                <button
                    type="submit"
                    disabled={loading}
                    className="w-full text-white bg-blue-700 hover:bg-blue-800 focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-lg text-sm px-5 py-2.5 transition duration-150 ease-in-out dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800 disabled:opacity-50"
                >
                    {loading ? 'Sending email...' : 'Submit'}
                </button>
                <button
                    type="button"
                    onClick={() => navigate('/')}
                    className="w-full mt-4 text-blue-700 hover:text-blue-900 focus:outline-none font-medium text-sm px-5 py-2.5 transition duration-150 ease-in-out"
                >
                    Back to Login
                </button>
            </form>
        </div>
    );
};

export default ForgotPasswordFn;
